import { useContext } from "react"
import fetchContext from '../context/fetch'

export default function useFetch() {
    return useContext(fetchContext)
}
